export default function About() {
    return (
        <>
            About
        </>
    );
}
